import { cva, type VariantProps } from 'class-variance-authority'
import { X } from 'lucide-react'
import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * Tag / Chip — removable pill. Pencil eh9Jj CvguQ HN8Z7 ouew1 1p0PH.
 */
export const tagVariants = cva(
  'inline-flex items-center gap-1 rounded-pill px-3 h-7 text-body-sm font-medium transition-colors',
  {
    variants: {
      tone: {
        neutral: 'bg-ia-elevated text-ia-text border border-ia-border',
        success: 'bg-ia-success-bg text-ia-success border border-ia-success/20',
        warning: 'bg-ia-warning-bg text-ia-warning border border-ia-warning/20',
        error: 'bg-ia-error-bg text-ia-error border border-ia-error/20',
        info: 'bg-ia-info-bg text-ia-info border border-ia-info/20',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
)

export interface TagProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof tagVariants> {
  onRemove?: () => void
  removeLabel?: string
}

export const Tag = React.forwardRef<HTMLSpanElement, TagProps>(
  ({ className, tone, onRemove, removeLabel = 'Remove', children, ...props }, ref) => (
    <span ref={ref} className={cn(tagVariants({ tone }), className)} {...props}>
      {children}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={removeLabel}
          className="-mr-1 ml-1 rounded-pill h-4 w-4 flex items-center justify-center transition-all hover:bg-[var(--color-ia-sidebar-active-glow)] hover:text-[var(--color-ia-sidebar-active-fg)] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        >
          <X size={12} strokeWidth={2} />
        </button>
      )}
    </span>
  ),
)
Tag.displayName = 'Tag'
